import styled from "styled-components";

import * as Dropdown from "ds/Dropdown";
import * as Radio from "ds/Radio";

export const FiltersWrapper = styled.div`
  display: flex;
  gap: 4px;

  span {
    overflow: visible;
  }
`;

export const RadioInput = styled(Radio.Input)`
  label {
    font-weight: 400;
  }
  cursor: pointer;
`;

export const RadioLabel = styled(Radio.Label)`
  margin-left: 0px;
  margin-top: 0px;
`;

export const DropdownTrigger = styled(Dropdown.Trigger)`
  border-radius: 8px;
  padding: 4px 8px;
  color: var(--mode-text-neutral-default-weak);

  &:focus,
  :active {
    border: 1px solid var(--mode-border-primary-strong);
    box-shadow:
      0px 0px 2px var(--mode-vector-primary-default),
      inset 0 0 2px var(--mode-vector-primary-default);
  }
`;
